import store from '@/core/config.store';
import { checkToken } from './checkToken';
import { ContentFormatTypeEnum } from './http';

/**
 *
 * default http config
 */
export const httpConfig = {
  timeout: 1000 * 30,
  baseURL: '/live-mall',
  format: ContentFormatTypeEnum.JSON,
  interceptor: {
    request(config) {
      return config;
    },
    response(response) {
      return response.data;
    },
    error(error) {
      const { response } = error;
      if (!response) {
        $$.vue.$toast('未响应！');
        return Promise.reject('未响应');
      }
      const { status } = response;

      if (status === 403) {
        console.log('登录失效！');
        // location.reload();
      } else if (status >= 500) {
        $$.vue.$toast('未知错误！');
      }
      return Promise.reject(response.data);
    }
  },
  validateStatus(status) {
    return status < 400;
  },
  tokenConfig: {
    key: 'Authorization',
    get() {
      return store.getters.mallToken;
    },
    checkToken() {
      return checkToken();
    }
  }
};
